(function (angular) {
	'use strict';

	var newsFeedItemObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			bodyTitle: '<',
			bodyText: '<',
			description: '<',
			displayDateFormatted: '<',
			displayDateMillis: '<',
			newsTitle: '<',
			associatedInvestorUpdate: '<',
			associatedReitElement: '<',
			associatedFirstInvestmentSnapshot: '<',
			type: '<'
		},
		controller: [
			'APP_BASE_PATH',
			'STATIC_BASE_PATH',
			'PropertyService',
			NewsFeedItemFunction
		],
		controllerAs: 'newsFeedItem'
	};

	angular
		.module('newsFeedModule')
		.component('newsFeedItem', newsFeedItemObject);

	function templateUrlFunction(STATIC_BASE_PATH) {
		return STATIC_BASE_PATH + '/static/html/investor-dashboard/news-feed/news-feed-item.html';
	}

	function NewsFeedItemFunction(APP_BASE_PATH, STATIC_BASE_PATH, PropertyService) {
		var newsFeedItem = this;

		newsFeedItem.$onInit = function() {
			newsFeedItem.basePath = APP_BASE_PATH;

			if(newsFeedItem.type === 'REIT_DIVIDEND') {
				newsFeedItem.newsTitle = 'You received a dividend.';
			} else if(newsFeedItem.type !== 'FIRST_INVESTMENT_SNAPSHOT') {

				var reitElement = newsFeedItem.associatedReitElement;
				var investorUpdate = newsFeedItem.associatedInvestorUpdate;

				newsFeedItem.linkUrl = APP_BASE_PATH + '/investor-update/' + investorUpdate.id + '/view';

				if(angular.isDefined(reitElement) && newsFeedItem.type === 'INVESTOR_UPDATE_ASSET_ACQUISITION') {
					newsFeedItem.newsTitle = 'New acquisition: ' + reitElement.projectType + ' in ' + reitElement.city + ', ' + reitElement.state;
				} else {
					newsFeedItem.newsTitle = newsFeedItem.associatedInvestorUpdate.title;
				}

				if(angular.isDefined(reitElement)) {
					newsFeedItem.associatedReitElement = PropertyService.formatPropertyListItem(newsFeedItem.associatedReitElement);
				}
			}
		};
	}
})(window.angular);